import React, { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { featuresData } from './data';

const Feature = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    setFeatures(featuresData);
  }, []);

  return (
    <div className="w-full py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {features.map((item, index) => (
            <Fade key={item.feature_id} delay={index * 150} triggerOnce direction="up">
              <div className="group relative bg-white p-8 rounded-[2.5rem] transition-all duration-500 border border-slate-100 hover:border-emerald-100 hover:shadow-[0_30px_60px_-15px_rgba(39,190,159,0.2)] flex flex-col items-start h-full overflow-hidden">
                {/* Subtle background glow on hover */}
                <div className="absolute -right-20 -top-20 w-64 h-64 bg-emerald-50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-3xl -z-10" />

                <div className="mb-8 relative">
                  <div className="w-20 h-20 rounded-2xl bg-slate-50 flex items-center justify-center transition-all duration-500 group-hover:bg-[#27be9f] group-hover:scale-110 group-hover:-rotate-3 shadow-inner">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="w-10 h-10 object-contain transition-all duration-500 group-hover:brightness-0 group-hover:invert"
                    />
                  </div>
                  {/* Icon ring decoration */}
                  <div className="absolute -inset-3 border-2 border-dashed border-slate-100 rounded-[2rem] opacity-0 group-hover:opacity-100 group-hover:rotate-12 transition-all duration-1000" />
                </div>

                <h6 className="text-2xl font-extrabold text-slate-800 mb-4 transition-colors duration-300 group-hover:text-[#27be9f]">
                  {item.title}
                </h6>

                <p className="text-slate-500 text-base leading-relaxed font-medium mb-6">
                  {item.des}
                </p>

                <div className="mt-auto flex items-center space-x-2">
                  <div className="w-12 h-1.5 bg-slate-100 rounded-full group-hover:bg-[#27be9f] transition-all duration-500 group-hover:w-20" />
                  <div className="w-1.5 h-1.5 bg-slate-100 rounded-full group-hover:bg-[#27be9f] transition-all duration-500 delay-75" />
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Feature;

